"use client";

import { createContext, useContext } from "react";

import { fetchApi } from "../api/client";
import type { User } from "./server";

interface AuthContextType {
  user: User | null;
}

const AuthContext = createContext<AuthContextType>({
  user: null,
});

export function useAuth() {
  return useContext(AuthContext);
}

interface AuthProviderProps {
  children: React.ReactNode;
  user: User | null;
}

export function AuthProvider({ children, user }: AuthProviderProps) {
  return (
    <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>
  );
}

type GoogleResponse = {
  token: string;
  user: {
    id: number;
    email: string;
    name: string;
    avatar_url: string | null;
  };
};

// Manage Google Cloud Console here: https://console.cloud.google.com/auth/clients/
export async function loginGoogleOAuth(
  credential: string,
): Promise<GoogleResponse> {
  const response = await fetchApi("api/v1/auth/google", {
    method: "POST",
    body: JSON.stringify({ auth: { token: credential } }),
  });

  const json = await response.json();

  if (!response.ok) {
    throw new Error(json.error || "Sign in with Google failed.");
  }

  return json;
}
